export abstract class TvrnLocalStorage {
  // biome-ignore-start lint/style/noRestrictedGlobals: this rule forces the use of this class, intended.
  static BROWSER = new (class extends TvrnLocalStorage {
    override async get(key: string): Promise<string | null> {
      return localStorage.getItem(key);
    }

    override async set(key: string, value: string): Promise<void> {
      return localStorage.setItem(key, value);
    }

    override async remove(key: string): Promise<void> {
      localStorage.removeItem(key);
    }
  })();
  // biome-ignore-end lint/style/noRestrictedGlobals: this rule forces the use of this class, intended.

  abstract get(key: string): Promise<string | null>;
  abstract set(key: string, value: string): Promise<void>;
  abstract remove(key: string): Promise<void>;
}
